import { render, staticRenderFns } from "./IconSvgMemberDirectory.vue?vue&type=template&id=6243c61f&scoped=true&"
import script from "./IconSvgMemberDirectory.vue?vue&type=script&lang=js&"
export * from "./IconSvgMemberDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243c61f",
  null
  
)

export default component.exports